import { apiClient } from "./apiClient";

/** Wraps the admin endpoints that actually exist today in
 * api/functions/admin.py -- every method here hits a real route. */
export const adminApi = {
  themeUsage: () => apiClient.get("/management/analytics/theme-usage").then((r) => r.data),
  featureUsage: () => apiClient.get("/management/analytics/feature-usage").then((r) => r.data),
  upgradeFunnel: () => apiClient.get("/management/analytics/upgrade-funnel").then((r) => r.data),
  dormantAccounts: () => apiClient.get("/management/analytics/dormant-accounts").then((r) => r.data),
  sentiment: () => apiClient.get("/management/analytics/sentiment").then((r) => r.data),
  costs: () => apiClient.get("/management/analytics/costs").then((r) => r.data),
  aiCosts: () => apiClient.get("/management/analytics/ai-costs").then((r) => r.data),
  subscriptionMetrics: () => apiClient.get("/management/analytics/subscription-metrics").then((r) => r.data),

  updateFeatureFlag: (featureName, defaultEnabled) =>
    apiClient.post("/management/feature-flags", { feature_name: featureName, default_enabled: defaultEnabled }).then((r) => r.data),

  slowQueries: () => apiClient.get("/management/slow-queries").then((r) => r.data),
  storageForecast: () => apiClient.get("/management/storage-forecast").then((r) => r.data),

  setMaintenanceMode: (enabled, message) => apiClient.post("/management/maintenance-mode", { enabled, message }).then((r) => r.data),

  searchAuditLog: (params) => apiClient.get("/management/audit-log", { params }).then((r) => r.data),

  /*
   * Undoing ONE change (#315). Two calls on purpose: the preview is not
   * a convenience, it is the review step. What it is worth reading is
   * not the list of fields that will go back -- it is the list that will
   * NOT, because their before-state is a redaction rather than a value,
   * and those stay wrong until somebody is told which they are.
   */
  previewRevert: (logId) =>
    apiClient.get(`/management/audit-log/${logId}/revert-preview`).then((r) => r.data),

  // fields omitted means every field the preview found restorable --
  // never every field in the before-state. The server intersects it
  // against its own plan, so a caller that skipped the preview still
  // cannot write a redaction back into a real address.
  applyRevert: (logId, fields) =>
    apiClient.post(`/management/audit-log/${logId}/revert`,
                   fields ? { fields } : {}).then((r) => r.data),

  triggerPenetrationTest: () => apiClient.post("/management/security/penetration-test").then((r) => r.data),

  listSupportTickets: (params) => apiClient.get("/management/support/tickets", { params }).then((r) => r.data),
  updateSupportTicket: (ticketId, status) => apiClient.put(`/management/support/tickets/${ticketId}`, { status }).then((r) => r.data),
};
